<template>
  <nav>
    <ul class="nav-box">
      <li v-for="x in routeList" :class="['nav-item', 'nav-'+x.path, getPath(route.path)==x.path?'nav-active':'']">
        <NuxtLink :to="'/'+x.path" v-if="x.path != 'product'">{{x.name}}</NuxtLink>
        <template v-if="x.path == 'product'">
          <a>{{x.name}}</a>
          <div class="product-box"><!-- 产品 -->
            <ul class="product-left">
              <li v-for="(y, index) in productList" :class="['left-item', index == productIndex? 'active' : '']" @mouseenter="handleMouseEnter(index)">
                <div class="name">{{ y.configKey }}</div>
                <div class="product-right" v-show="index == productIndex">
                  <client-only>
                    <el-scrollbar>
                      <NuxtLink :to="'/product/'+z.configId" v-for="z in y.children" class="right-item" :title="'点击查看 '+z.configKey">
                        <div class="img" :style="[z.configPictureUrl? {'background-image': 'url('+z.configPictureUrl+')'} : '']"></div>
                        <span>{{ z.configKey }}</span>
                      </NuxtLink>
                    </el-scrollbar>
                  </client-only>
                </div>
              </li>
            </ul>
            <!-- <div class="text">
              <p>{{ t('product.text1') }}</p>
              <span>{{ t('product.text2') }}</span>
            </div> -->
          </div>
        </template>
      </li>
    </ul>
  </nav>
</template>
<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'
  const { t, locale } = useI18n();
  const routeList = ref([
    {name: t("menu.home"), path: ''},
    {name: t("menu.brandStory"), path: 'brandStory'},
    {name: t("menu.product"), path: 'product'},
    {name: t("menu.support"), path: 'support'},
    {name: t("menu.case"), path: 'case'},
    {name: t("menu.news"), path: 'news'},
    {name: t("menu.dynamics"), path: 'dynamics'}
  ])
  watch(
    () => locale.value,
    () => {
      routeList.value = [
        {name: t("menu.home"), path: ''},
        {name: t("menu.brandStory"), path: 'brandStory'},
        {name: t("menu.product"), path: 'product'},
        {name: t("menu.support"), path: 'support'},
        {name: t("menu.case"), path: 'case'},
        {name: t("menu.news"), path: 'news'},
        {name: t("menu.dynamics"), path: 'dynamics'}
      ]
      getList()
    }
  );
 
  const productList: any= ref([ ])

  const route = useRoute()
  const getPath = (x:any)=>{
    return x.split("/")[1]
  }

  let productIndex = ref(0)
  const handleMouseEnter = (index: any) => {
    productIndex.value = index
  }

  const getList = async() => { // 获取数据
    productList.value= []
    try {
      const response = await treeConfigUntilModel(locale.value);
      if(response.data.length){
        productList.value = response.data
      }else{
        productList.value= []
      }
    } catch (error) {
    }
  }
  getList()
</script>

<style lang="scss" scoped>
  nav {
    height: 49px;
    .nav-box {
      display: flex;
      .nav-item {
        position: relative;
        padding: 15px 0 17px;
        height: 49px;
        &.nav-active:after,&:hover:after{
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 8px;
          background: #01a2e0;
          border-radius: 8px;
        }
        &>a {
          display: inline-block;
          font-size: inherit;
          padding: 0 24px;
          color: #2f2f2f;
          vertical-align: bottom;
          cursor: pointer;
        }
      }
      
      .nav-product{
        .product-box{
          transition: opacity 0.5s;
          background-color: #fff;
          position: fixed;
          left: 0;
          right: 0;
          top: 68px;
          width: 100%;
          padding-top: 60px;
          height: 550px;
          color: #000;
          visibility: hidden;
          opacity: 0;
          z-index: 100;
          .product-left{
            float: left;
            width: 15.5%;
            border-right: 5px solid #eee;
            height: 450px;
            .left-item{
              .name{
                text-align: right;
                height: 90px;
                padding-top: 20px;
                margin-bottom: 40px;
                padding-right: 33px;
                cursor: pointer;
                font-size: 24px;  
              }
              &.active{
                .name{
                  color: #01a2e0;
                  border-right: 5px solid #01a2e0;
                  margin-right: -5px;  
                }
              }
              &:last-child{
                .name{
                  height: 60px;
                }
              }
            }
          }
          .product-right{
            position: absolute;
            left: 15.5%;
            top: 47px;
            right: 0;
            padding-left: 4.7%;
            bottom: 5px;
            .right-item{
              width: 20%;
              text-align: center;
              cursor: pointer;
              margin: 0 2% 23px ;
              display: inline-block;
              font-size: 18px;
              color: inherit;
              .img{
                height: 184px;
                background: no-repeat center center;
                background-size: auto 100%;
                margin-bottom: 24px;
              }
            }
          }
          .text{
            position: absolute;
            bottom: 15px;
            left: 3%;
            p{
              font-size: 30px;
              margin-bottom: 16px;
            }
            span{
              font-size: 21px;
            }
          }
        }
        &:hover{
          .product-box{
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }
</style>